import { type SnapshotId, isCompareGraphOverlay } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { option } from 'fp-ts';
import { constNull, flow } from 'fp-ts/lib/function';

export const selectSnapshotToCompareId: (s: GraphState) => SnapshotId | null =
  flow(
    prop('overlay'),
    option.fromPredicate(isCompareGraphOverlay),
    option.fold(constNull, prop('snapshotToCompare')),
  );
